import { render, staticRenderFns } from "./ChildUsers.vue?vue&type=template&id=f7a04a64&"
import script from "./ChildUsers.vue?vue&type=script&lang=js&"
export * from "./ChildUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports